

export const frontMatter = {
	sidebar_position: 4,
	license: 'republish',
	author: 'Jan van Steenbergen',
	custom_edit_url: '/501',
	last_update: {
		author: 'Google Translate'
	},
	origin: 'http://steen.free.fr/interslavic/numerals.html'
};
export const contentTitle = 'Цифри';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-bg-docusaurus-plugin-content-docs-current-learn-grammar-numerals-md-eee.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Кардинални числа",
  "id": "cardinal-numbers",
  "level": 2
}, {
  "value": "Склонение на кардиналните числа",
  "id": "declension-of-cardinal-numbers",
  "level": 3
}, {
  "value": "1",
  "id": "1",
  "level": 4
}, {
  "value": "2-4",
  "id": "2-4",
  "level": 4
}, {
  "value": "5-99",
  "id": "5-99",
  "level": 4
}, {
  "value": "0, 100, 1000, 106, 109",
  "id": "0-100-1000-106-109",
  "level": 4
}, {
  "value": "Неопределени числа",
  "id": "indefinite-numbers",
  "level": 3
}, {
  "value": "Поредни числа",
  "id": "ordinal-numbers",
  "level": 2
}, {
  "value": "Дроби",
  "id": "fractions",
  "level": 2
}, {
  "value": "Колективни номера",
  "id": "collective-numbers",
  "level": 2
}, {
  "value": "Умножителни числа",
  "id": "multiplicative-numbers",
  "level": 2
}, {
  "value": "Диференциални числа",
  "id": "differential-numbers",
  "level": 2
}, {
  "value": "Субстантивирани числа",
  "id": "substantivised-numbers",
  "level": 2
}, {
  "value": "Раждане на близнаци",
  "id": "twin-births",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    em: "em",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDNumerals1, MDNumerals2, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDNumerals1) _missingMdxReference("MDNumerals1", true);
  if (!MDNumerals2) _missingMdxReference("MDNumerals2", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "цифри",
        children: "Цифри"
      })
    }), "\n", _jsx(_components.h2, {
      id: "cardinal-numbers",
      children: "Кардинални числа"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Малко може да се каже за въвеждане на кардиналните числа, така че нека преминем към формите:"
    }), "\n", _jsxs(_components.p, {
      children: ["Числата 0-10 са:\n0. ", _jsx(_components.code, {
        children: "nula"
      }), ", 1. ", _jsx(_components.code, {
        children: "jedin"
      }), " (", _jsx(_components.code, {
        children: "jedna"
      }), ", ", _jsx(_components.code, {
        children: "jedno"
      }), "), 2. ", _jsx(_components.code, {
        children: "dva"
      }), " (", _jsx(_components.code, {
        children: "dvě"
      }), "), 3. ", _jsx(_components.code, {
        children: "tri"
      }), ", 4. ", _jsx(_components.code, {
        children: "četyri"
      }), ", 5. ", _jsx(_components.code, {
        children: "pet"
      }), ", 6. ", _jsx(_components.code, {
        children: "šest"
      }), ", 7. ", _jsx(_components.code, {
        children: "sedm"
      }), ", 8. ", _jsx(_components.code, {
        children: "osm"
      }), ", 9. ", _jsx(_components.code, {
        children: "devet"
      }), ", 10. ", _jsx(_components.code, {
        children: "deset"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["-teens (11-19) се формират чрез добавяне на ", _jsx(_components.code, {
        children: "-nadset"
      }), " (произнася се ", _jsxs(_components.em, {
        children: ["-", _jsx(_components.code, {
          children: "nacet"
        })]
      }), ") към числата 1-9:\n11. ", _jsx(_components.code, {
        children: "jedinnadset"
      }), ", 12. ", _jsx(_components.code, {
        children: "dvanadset"
      }), ", 13. ", _jsx(_components.code, {
        children: "trinadset"
      }), ", 14. ", _jsx(_components.code, {
        children: "četyrinadset"
      }), ", 15. ", _jsx(_components.code, {
        children: "petnadset"
      }), ", 16. ", _jsx(_components.code, {
        children: "šestnadset"
      }), ", 17. ", _jsx(_components.code, {
        children: "sedmnadset"
      }), ", 18. ", _jsx(_components.code, {
        children: "osmnadset"
      }), ", 19. ", _jsx(_components.code, {
        children: "devetnadset"
      }), " 27."]
    }), "\n", _jsxs(_components.p, {
      children: ["„Връзките” (20-90) се образуват чрез добавяне на ", _jsx(_components.code, {
        children: "-deset"
      }), " към числата 2-9:\n20. ", _jsx(_components.code, {
        children: "dvadeset"
      }), ", 30. ", _jsx(_components.code, {
        children: "trideset"
      }), ", 40. ", _jsx(_components.code, {
        children: "četyrideset"
      }), ", 50. ", _jsx(_components.code, {
        children: "petdeset"
      }), ", 60. ", _jsx(_components.code, {
        children: "šestdeset"
      }), ", 70. ", _jsx(_components.code, {
        children: "sedmdeset"
      }), ", 80. ", _jsx(_components.code, {
        children: "osmdeset"
      }), ", 90. ", _jsx(_components.code, {
        children: "devetdeset"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Стотиците (100-900) се образуват чрез добавяне на ", _jsx(_components.code, {
        children: "-sto"
      }), " към числата 2-9:\n100. ", _jsx(_components.code, {
        children: "sto"
      }), ", 200. ", _jsx(_components.code, {
        children: "dvasto"
      }), ", 300. ", _jsx(_components.code, {
        children: "tristo"
      }), ", 400. ", _jsx(_components.code, {
        children: "četyristo"
      }), ", 500. ", _jsx(_components.code, {
        children: "petsto"
      }), ", 600. ", _jsx(_components.code, {
        children: "šeststo"
      }), ", 700. ", _jsx(_components.code, {
        children: "sedmsto"
      }), ", 800. ", _jsx(_components.code, {
        children: "osmsto"
      }), ", 900. ", _jsx(_components.code, {
        children: "devetsto"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Като алтернатива, стотиците могат също да бъдат образувани чрез сгъване на думата ", _jsx(_components.code, {
        children: "sto"
      }), ", което води до следния набор:\n100. ", _jsx(_components.code, {
        children: "sto"
      }), ", 200. ", _jsx(_components.code, {
        children: "dvěstě"
      }), ", 300. ", _jsx(_components.code, {
        children: "trista"
      }), ", 400. ", _jsx(_components.code, {
        children: "četyrista"
      }), ", 500. ", _jsx(_components.code, {
        children: "petsot"
      }), ", 600. ", _jsx(_components.code, {
        children: "šestsot"
      }), ", 700. ", _jsx(_components.code, {
        children: "sedmsot"
      }), ", 800. ", _jsx(_components.code, {
        children: "osmsot"
      }), ", 900. ", _jsx(_components.code, {
        children: "devetsot"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Думите за „хиляда”, „милион” и „милиард” са: ", _jsx(_components.code, {
        children: "tyseč"
      }), " (1000), ", _jsx(_components.code, {
        children: "milion"
      }), " (106) и ", _jsx(_components.code, {
        children: "miliard"
      }), " (109). Точно както в случая със стотиците, тези думи могат или не могат да бъдат склонени като съществителни. Въпреки че не е обичайно в славянските езици да се прави това, в случаи като ", _jsx(_components.code, {
        children: "pet-tyseć"
      }), " „5000” може да се добави тире за яснота."]
    }), "\n", _jsxs(_components.p, {
      children: ["Комбинации от тях винаги се правят от високо към ниско: хиляди – стотици – десетки – единици. Между десетиците и единиците може да се вмъкне думата ", _jsx(_components.code, {
        children: "i"
      }), " „и”. Например: ", _jsx(_components.code, {
        children: "tri-tyseč četyristo petdeset (i) šest"
      }), " „3,456”."]
    }), "\n", _jsx(_components.p, {
      children: "Тъй като основната цел на междуславянския език е да бъде максимално разбран от говорещите славянски език, той заслужава препоръка да се пишат цифри вместо цифрови думи."
    }), "\n", _jsxs(_components.p, {
      children: ["За средния западняк би имало най-голям смисъл, ако думата ", _jsx(_components.code, {
        children: "jedin"
      }), " бъде последвана от съществително в единствено число, а всички останали числа от съществително в множествено число: ", _jsx(TransliteratorElement, {
        children: "jedin dom, dva domy, pet domy, dvadeset domy, milion domy"
      }), ". В славянските езици обаче нещата работят по друг начин. Всички числа, по-високи от 4, са последвани от родителен падеж на множествено число: ", _jsx(TransliteratorElement, {
        children: "pet domov"
      }), " (букв. „пет къщи”). В случая с числата 2-4 повечето езици използват в повечето случаи именителен падеж множествено число, но някои езици, особено сърбохърватски и руски, предпочитат вместо това родителния падеж единствено число. От съображения за яснота обаче се препоръчва да се използва именителен падеж единствено число след 1, именителен падеж множествено число след 2-4 и родителен падеж множествено число след 5 и повече: ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "jedin dom, dva domy, četyri domy, pet domov"
        })
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "declension-of-cardinal-numbers",
      children: "Склонение на кардиналните числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Най-лесното решение за деклинирането на кардиналните числа е просто да не ги деклинирате изобщо. ", _jsx(_components.em, {
        children: "Dom s tri etažami"
      }), " „Къща на три етажа” е напълно разбираема, въпреки че може да звучи малко странно за носителите на езика. Въпреки това, по-добър ефект може да се постигне чрез използване на следните модели за склонение:"]
    }), "\n", _jsx(_components.h4, {
      id: "1",
      children: "1"
    }), "\n", _jsxs(_components.p, {
      children: ["С изключение на именителния падеж в единствено число от мъжки род, думата ", _jsx(_components.code, {
        children: "jedin"
      }), " „един” се склонява като прилагателно ", _jsxs(_components.strong, {
        children: ["*@", _jsx(_components.code, {
          children: "jedny"
        })]
      }), ": m. ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "jedin"
        }), ", ", _jsx(_components.code, {
          children: "jednogo"
        })]
      }), ", е. ", _jsxs(_components.strong, {
        children: [_jsx(_components.code, {
          children: "jedna"
        }), ", ", _jsx(_components.code, {
          children: "jednoj"
        })]
      }), ", n. ", _jsx(_components.code, {
        children: "jedno"
      }), " и т.н. В някои случаи може да се използва и в множествено число: ", _jsx(TransliteratorElement, {
        children: "Jedni ljudi prědpočitajut lěto, drugi zimu"
      }), " „Някои хора предпочитат лятото, други зимата”. Такъв е и случаят с pluralia tantum: ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "jedne dveri"
        })
      }), " „една врата”."]
    }), "\n", _jsx(_components.h4, {
      id: "2-4",
      children: "2-4"
    }), "\n", _jsxs(_components.p, {
      children: ["Тези числа са намалени по малко непознат начин, защото техните модели показват остатъци от древния дуал. Само ", _jsx(_components.code, {
        children: "dva"
      }), " „две” има разграничение по род, макар и само в именителен/винителен падеж."]
    }), "\n", _jsx(MDNumerals1, {}), "\n", _jsxs(_components.p, {
      children: ["Средният род на \"2\" е ", _jsx(_components.code, {
        children: "dva"
      }), " на руски, беларуски, украински, полски, кашубски и сърбохърватски, ", _jsx(_components.code, {
        children: "dvě"
      }), " на старославянски, чешки, словашки, горен и долен лужишки, словенски, македонски, български и русински. В междуславянския и двата варианта са еднакво валидни."]
    }), "\n", _jsxs(_components.p, {
      children: ["Също така отклонени като ", _jsx(_components.code, {
        children: "dva"
      }), " са думите ", _jsx(_components.code, {
        children: "oba"
      }), " и ", _jsx(_components.code, {
        children: "obydva"
      }), " „и двете“, „двамата от“."]
    }), "\n", _jsx(_components.h4, {
      id: "5-99",
      children: "5-99"
    }), "\n", _jsxs(_components.p, {
      children: ["Числата ", _jsx(_components.code, {
        children: "pet"
      }), " и нагоре се сгъват като съществителни от модела ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "kost"
        })
      }), ". Подлогът винаги остава в родителен падеж множествено число. Примери:"]
    }), "\n", _jsx(MDNumerals2, {}), "\n", _jsx(_components.h4, {
      id: "0-100-1000-106-109",
      children: "0, 100, 1000, 106, 109"
    }), "\n", _jsxs(_components.p, {
      children: ["Останалите числа също се отклоняват като съществителни: ", _jsx(_components.code, {
        children: "nula"
      }), " „нула” като съществително от женски род (като ", _jsx(TransliteratorElement, {
        children: "žena"
      }), "), ", _jsx(_components.code, {
        children: "sto"
      }), " „сто” като съществително от среден род (като ", _jsx(TransliteratorElement, {
        children: "slovo"
      }), "), ", _jsx(_components.code, {
        children: "tyseč"
      }), " „хиляда” като съществително от мъжки или женски род (ген. ", _jsx(TransliteratorElement, {
        children: "tyseča"
      }), " или ", _jsx(TransliteratorElement, {
        children: "tyseči"
      }), "), ", _jsx(_components.code, {
        children: "milion"
      }), " „милион” и ", _jsx(_components.code, {
        children: "miliard"
      }), " „милиард” (или „милиард”) като съществителни от мъжки род."]
    }), "\n", _jsx(_components.h3, {
      id: "indefinite-numbers",
      children: "Неопределени числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Освен изброените по-горе количествени числа, има и категория от така наречените ", _jsx(_components.em, {
        children: "неопределени кардинални числа"
      }), ", състояща се от думи като ", _jsx(_components.code, {
        children: "mnogo"
      }), " „много, много”, ", _jsx(_components.code, {
        children: "malo"
      }), " „малко, малко”, ", _jsx(_components.code, {
        children: "velje"
      }), " „много” , ", _jsx(_components.code, {
        children: "veče"
      }), " „повече”, ", _jsx(_components.code, {
        children: "menje"
      }), " „по-малко”, ", _jsx(_components.code, {
        children: "koliko"
      }), " „колко”, ", _jsx(_components.code, {
        children: "několiko"
      }), " „няколко, някои”, ", _jsx(_components.code, {
        children: "toliko"
      }), " „това/това много”, ", _jsx(_components.code, {
        children: "para"
      }), " „няколко” ."]
    }), "\n", _jsx(_components.h2, {
      id: "ordinal-numbers",
      children: "Поредни числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Поредните числа, грубо казано, се отнасят до мястото на даден елемент в ред. От гледна точка на граматиката, тези думи са прилагателни и също като обикновените прилагателни те съвпадат със съществителното, което променят по род, падеж и число. Всички редни числителни се сгъват като прилагателни с твърда основа (като ", _jsx(TransliteratorElement, {
        children: "dobry"
      }), "), с изключение на ", _jsx(_components.code, {
        children: "trětji"
      }), ", което следва мекото склонение (като ", _jsx(_components.em, {
        children: _jsx(_components.code, {
          children: "svěži"
        })
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["Поредните номера от 1 до 4 са: ", _jsx(_components.code, {
        children: "prvy"
      }), " „първи”, ", _jsx(_components.code, {
        children: "drugy"
      }), " или ", _jsx(_components.code, {
        children: "vtory"
      }), " „втори”, ", _jsx(_components.code, {
        children: "trětji"
      }), " „трети” и ", _jsx(_components.code, {
        children: "četvrty"
      }), " „четвърти”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Останалите редни числа до 99 се образуват чрез добавяне на края ", _jsx(_components.code, {
        children: "-y"
      }), " към кардиналните числа:\n", _jsx(TransliteratorElement, {
        children: "pety"
      }), " „5-ти”, ", _jsx(_components.code, {
        children: "šesty"
      }), " „6-ти”, ", _jsx(_components.code, {
        children: "sedmy"
      }), " „7-ми”, ", _jsx(_components.code, {
        children: "osmy"
      }), " „8-ми”, ", _jsx(_components.code, {
        children: "devety"
      }), " „9-ти”, ", _jsx(_components.code, {
        children: "desety"
      }), " „10-ти”; ", _jsx(_components.code, {
        children: "jedinnadsety"
      }), " „11-ти”, ", _jsx(_components.code, {
        children: "dvadesety"
      }), " „20-ти” и т.н."]
    }), "\n", _jsxs(_components.p, {
      children: ["Думата за „100-ия” е ", _jsx(_components.code, {
        children: "sotny"
      }), " или ", _jsx(_components.code, {
        children: "stoty"
      }), ", думата за „1000-ния” е ", _jsx(_components.code, {
        children: "tysečny"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Когато по-голямо число образува низ, само последният член се модифицира, за да създаде пореден номер: ", _jsx(_components.em, {
        children: "v tyseč devetsot osmdeset četvrtom godu"
      }), " „в годината 1984”."]
    }), "\n", _jsx(_components.h2, {
      id: "fractions",
      children: "Дроби"
    }), "\n", _jsxs(_components.p, {
      children: ["Повечето славянски езици използват редните числа за дроби: ", _jsx(_components.code, {
        children: "dvě trětje"
      }), " „две трети, 2/3”. Въпреки това, от съображения за яснота, ако заслужава препоръка вместо това да използвате следните, универсално разбираеми форми:"]
    }), "\n", _jsxs(_components.p, {
      children: ["Думата за „половината” е ", _jsx(_components.code, {
        children: "pol"
      }), " (", _jsx(_components.code, {
        children: "polovina"
      }), ", ", _jsx(_components.code, {
        children: "polovica"
      }), "). Може да се използва и като префикс: ", _jsx(_components.code, {
        children: "pol-mrtvy"
      }), " „полумъртви”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Всички други форми са изградени чрез заместване на края ", _jsx(_components.code, {
        children: "-y"
      }), " на поредните номера на ", _jsx(_components.code, {
        children: "-ina"
      }), ": ", _jsx(_components.code, {
        children: "tretjina"
      }), " „1/3”, ", _jsx(_components.code, {
        children: "četvrtina"
      }), " „1/4”, ", _jsx(_components.code, {
        children: "petina"
      }), " „1/5”, ", _jsx(_components.code, {
        children: "šestina"
      }), " „1/6”, ", _jsx(_components.code, {
        children: "sedmina"
      }), " „1/7”, ", _jsx(_components.code, {
        children: "osmina"
      }), " „1/8”, ", _jsx(_components.code, {
        children: "devetina"
      }), " „1/9”, ", _jsx(_components.code, {
        children: "desetina"
      }), " „1/10”. Това работи и за по-големи числа: ", _jsx(_components.code, {
        children: "šestnadsetina"
      }), " „1/16”, ", _jsx(_components.code, {
        children: "sotina"
      }), " или ", _jsx(_components.code, {
        children: "stotina"
      }), " „1/100”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Те се накланят като съществителни от женски род. По този начин „7/38” се представя като ", _jsx(_components.code, {
        children: "sedm trideseti-osmin"
      }), " (тирето има за цел да подобри яснотата)."]
    }), "\n", _jsx(_components.h2, {
      id: "collective-numbers",
      children: "Колективни номера"
    }), "\n", _jsx(_components.p, {
      children: "Кардиналните и поредните числа са най-значимите. Но славянските езици имат и други категории. Повечето от тях се използват рядко в днешно време или се използват само при определени обстоятелства, но все пак трябва да бъдат споменати от съображения за пълнота."
    }), "\n", _jsxs(_components.p, {
      children: ["Колективните числа се отнасят до членове на затворена група и могат да се преведат като „група от”, „някои”. Формите са:\n", _jsx(TransliteratorElement, {
        children: "dvoje"
      }), " „двама, двойка”, ", _jsx(_components.code, {
        children: "troje"
      }), " „тройка, група от трима”, ", _jsx(_components.code, {
        children: "četvero"
      }), ", ", _jsx(_components.code, {
        children: "petero"
      }), ", ", _jsx(_components.code, {
        children: "šestero"
      }), ", ", _jsx(_components.code, {
        children: "sedmero"
      }), ", ", _jsx(_components.code, {
        children: "osmero"
      }), ", ", _jsx(_components.code, {
        children: "devetero"
      }), ", ", _jsx(_components.code, {
        children: "desetero"
      }), ". Тази група включва също ", _jsx(_components.code, {
        children: "oboje"
      }), " „и двете”."]
    }), "\n", _jsx(_components.p, {
      children: "Може да се използва вместо кардинално число в следните случаи:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["когато групата се състои от мъже и жени: ", _jsx(TransliteratorElement, {
          children: "dva studenti"
        }), " „двама студенти (м.)”, ", _jsx(TransliteratorElement, {
          children: "dvě studentky"
        }), " „двама студенти (ж.)”, ", _jsx(TransliteratorElement, {
          children: "dvoje studentov"
        }), " „двама студенти (м. + ж.)”"]
      }), "\n", _jsxs(_components.li, {
        children: ["с неутрални по пол думи като ", _jsx(_components.code, {
          children: "ljudi"
        }), " и ", _jsx(_components.code, {
          children: "děti"
        }), ": ", _jsx(TransliteratorElement, {
          children: "osmero ljudij"
        }), " „осем души”, ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "četvero dětij"
          })
        }), " „четири деца”"]
      }), "\n", _jsxs(_components.li, {
        children: ["с думи от среден род, обозначаващи млади животни (sg. ", _jsx(_components.code, {
          children: "-e"
        }), ", pl. ", _jsx(_components.code, {
          children: "-eta"
        }), "): ", _jsx(_components.em, {
          children: _jsx(_components.code, {
            children: "troje telet"
          })
        }), " „три телета”"]
      }), "\n", _jsxs(_components.li, {
        children: ["за обекти, които естествено идват по двойки, например: ", _jsx(TransliteratorElement, {
          children: "dvoje rųkavic"
        }), " „две ръкавици”"]
      }), "\n", _jsxs(_components.li, {
        children: ["с думи, които съществуват само в множествено число (", _jsx(_components.em, {
          children: "pluralia tantum"
        }), "): ", _jsx(TransliteratorElement, {
          children: "dvoje dverij"
        }), " „две врати”."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Както се вижда от тези примери, съществителното име след сборно числително винаги е в родителен падеж на множествено число и ако това съществително е предмет на изречение, съответният глагол е в 3-то лице единствено число (среден род)."
    }), "\n", _jsxs(_components.p, {
      children: ["Събирателните числа могат да се използват и без съществително в случаи като: ", _jsx(_components.code, {
        children: "my oboje"
      }), " „и двамата (м. + ж.)”, ", _jsx(_components.code, {
        children: "zabava v troje"
      }), " „парти за трима”."]
    }), "\n", _jsx(_components.h2, {
      id: "multiplicative-numbers",
      children: "Умножителни числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Основите на събирателните числителни също могат да се използват като основа за мултипликативни (или сборни) прилагателни: ", _jsx(_components.code, {
        children: "dvojny"
      }), " „двоен, двукратен”, ", _jsx(_components.code, {
        children: "trojny"
      }), " „троен, троен, троен”, ", _jsx(_components.code, {
        children: "četverny"
      }), " „четворен, четирикратен”. По-рядко срещани, но не и невъзможни, са по-високите числа: ", _jsx(_components.code, {
        children: "peterny"
      }), " „петор“, ", _jsx(_components.code, {
        children: "šesterny"
      }), " „шест“ и т.н. Към същото семейство принадлежи и ", _jsx(_components.code, {
        children: "jediny"
      }), " „само, единичен“."]
    }), "\n", _jsxs(_components.p, {
      children: ["С префикса ", _jsx(_components.code, {
        children: "po-"
      }), " тези прилагателни също могат да се превърнат в глаголи: ", _jsx(_components.code, {
        children: "podvojiti"
      }), " „удвоявам”, ", _jsx(_components.code, {
        children: "potrojiti"
      }), " „утроявам”, ", _jsx(_components.code, {
        children: "početveriti"
      }), " „умножавам по четири”. Обратното може да се постигне с префикса ", _jsx(_components.code, {
        children: "raz-"
      }), ": ", _jsx(_components.code, {
        children: "razdvojiti"
      }), " „да се раздели на две”, ", _jsx(_components.code, {
        children: "raztrojiti"
      }), " „да се раздели на три части”."]
    }), "\n", _jsxs(_components.p, {
      children: ["Друг вид умножителни числителни са наречията, образувани чрез добавяне на наставката ", _jsx(_components.code, {
        children: "-kratno"
      }), " към кардиналното число: ", _jsx(_components.code, {
        children: "jednokratno"
      }), " „веднъж, веднъж”, ", _jsx(_components.code, {
        children: "dvakratno"
      }), " „два пъти, два пъти”, ", _jsx(_components.code, {
        children: "trikratno"
      }), " „три пъти, три пъти” , и т.н. Този суфикс може да се използва и за неопределени числа: ", _jsx(_components.code, {
        children: "mnogokratno"
      }), " „много пъти”, ", _jsx(_components.code, {
        children: "několikokratno"
      }), " „няколко пъти”."]
    }), "\n", _jsx(_components.h2, {
      id: "differential-numbers",
      children: "Диференциални числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Друга група прилагателни с числителна основа са диференциалните (качествени, родови) числа. Те се отнасят до качествена диференциация на въпросните елементи и могат да бъдат преведени като „различни видове“. Стара форма (базирана отново на колективните числа) е ", _jsx(_components.code, {
        children: "dvoj"
      }), ", ", _jsx(_components.code, {
        children: "troj"
      }), " (отклонена като притежателното местоимение ", _jsx(_components.code, {
        children: "moj"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["По-често срещано и по-малко объркващо обаче е окончанието ", _jsx(_components.code, {
        children: "-aky"
      }), ": ", _jsx(_components.code, {
        children: "dvojaky"
      }), ", ", _jsx(_components.code, {
        children: "trojaky"
      }), ", ", _jsx(_components.code, {
        children: "četveraky"
      }), ", ", _jsx(_components.code, {
        children: "peteraky"
      }), ", и т.н.: ", _jsx(TransliteratorElement, {
        children: "dvojake knigy"
      }), " „два вида книги“. Това работи и за неопределени числа: ", _jsx(_components.code, {
        children: "kolikoraky"
      }), " „колко вида“."]
    }), "\n", _jsxs(_components.p, {
      children: ["Когато се адвербиализира, значението става нещо като „по X начини”: ", _jsx(_components.code, {
        children: "trojako"
      }), " „по три начина”."]
    }), "\n", _jsx(_components.h2, {
      id: "substantivised-numbers",
      children: "Субстантивирани числа"
    }), "\n", _jsxs(_components.p, {
      children: ["Понякога числата се използват като субстантиви, например когато говорим за рисунка или скулптура на число, автобус, радио или телевизионен канал, оценка, дадена в училище, банкнота или карта за игра. Може просто да се преведе като „тройка”, „петицата” и т.н. В случая на числата 2-4 това става чрез добавяне на окончанието ", _jsx(_components.code, {
        children: "-ka"
      }), " към сборната числителна основа, в останалите случаи към кардинален номер: ", _jsx(_components.code, {
        children: "jedinka"
      }), ", ", _jsx(_components.code, {
        children: "dvojka"
      }), ", ", _jsx(_components.code, {
        children: "trojka"
      }), ", ", _jsx(_components.code, {
        children: "četverka"
      }), ", ", _jsx(_components.code, {
        children: "petka"
      }), ", ", _jsx(_components.code, {
        children: "šestka"
      }), ", и т.н."]
    }), "\n", _jsxs(_components.p, {
      children: ["Като алтернатива може да се използва и окончанието ", _jsx(_components.code, {
        children: "-ica"
      }), ", но това не работи във всички случаи: ", _jsx(_components.code, {
        children: "jedinica"
      }), ", ", _jsx(_components.code, {
        children: "petica"
      }), ", ", _jsx(_components.code, {
        children: "šestica"
      }), ", ", _jsx(_components.code, {
        children: "sedmica"
      }), " и т.н."]
    }), "\n", _jsx(_components.h2, {
      id: "twin-births",
      children: "Раждане на близнаци"
    }), "\n", _jsx(_components.p, {
      children: "Донякъде специален случай представлява броят на децата от едно раждане: близнаци, тризнаци, четворки, петзнаци и др. Славянските езици имат различни начини за изразяване на това:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Източнославянски: ", _jsx(_components.code, {
          children: "-ne"
        }), " (pl. ", _jsx(_components.code, {
          children: "-neta"
        }), ") – ", _jsx(_components.code, {
          children: "dvojne"
        }), ", ", _jsx(_components.code, {
          children: "trojne"
        }), ", ", _jsx(_components.code, {
          children: "četverne"
        }), ", ", _jsx(_components.code, {
          children: "peterne"
        }), " (1 от 2, 3, 4, 5)"]
      }), "\n", _jsxs(_components.li, {
        children: ["чешко-словашки: ", _jsx(_components.code, {
          children: "-če"
        }), " (pl. ", _jsx(_components.code, {
          children: "-četa"
        }), ") - ", _jsx(_components.code, {
          children: "dvojče"
        }), ", ", _jsx(_components.code, {
          children: "trojče"
        }), ", ", _jsx(_components.code, {
          children: "četverče"
        }), ", ", _jsx(_components.code, {
          children: "peterče"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Полски: ", _jsx(_components.code, {
          children: "-ak"
        }), " - ", _jsx(_components.code, {
          children: "dvojak"
        }), ", ", _jsx(_components.code, {
          children: "trojak"
        }), ", ", _jsx(_components.code, {
          children: "četverak"
        }), ", ", _jsx(_components.code, {
          children: "peterak"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Словенски: ", _jsx(_components.code, {
          children: "-ček"
        }), " – ", _jsx(_components.code, {
          children: "dvojček"
        }), ", ", _jsx(_components.code, {
          children: "trojček"
        }), ", ", _jsx(_components.code, {
          children: "četverček"
        }), ", ", _jsx(_components.code, {
          children: "peterček"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["Южнославянски: ", _jsx(_components.code, {
          children: "-ka"
        }), " - ", _jsx(_components.code, {
          children: "dvojka"
        }), ", ", _jsx(_components.code, {
          children: "trojka"
        }), ", ", _jsx(_components.code, {
          children: "četverka"
        }), ", ", _jsx(_components.code, {
          children: "peterka"
        })]
      }), "\n"]
    }), "\n", "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

